import { FC, ReactNode } from 'react';
import React from 'react';
import { useWindowWidth } from '@investoro/core';
import styled from 'styled-components';

interface ChatbotWindowProps {
  children: ReactNode;
  isChatbot?: boolean;
}

const Container = styled.div<{ isChatbot?: boolean; isMobile: boolean }>`
  position: relative;
  z-index: 100;
  
  ${(props) => props.isChatbot && props.isMobile && `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
  `}
`;

const WindowWrapper = styled.div<{ isChatbot?: boolean }>`
    display: flex;
    flex-direction: column;
    background: var(--color-white);
    border-radius: var(--box-border-radius);
    box-shadow: ${(props) => props.isChatbot ? '0 14px 40px 0 rgba(0, 0, 0, 0.70)' : '0 0 40px 0 rgba(0, 0, 0, 0.20)'};
    z-index: 100;
    overflow: hidden;
  
  ${(props) => !props.isChatbot && `
        width: 270px;
        max-height: 600px;
        height: calc(100vh - 40%);
        margin: 15px;
        
  `}
  
  ${(props) => props.isChatbot && `
        min-width: 300px;
        max-height: 75vh;
        height: auto;
        display: flex;
        flex-direction: column;
        margin: 0 5px;

        @media (max-width: 767px) {
            width: 100%;
            height: 75vh;
        }

        @media (min-width: 768px) {
            width: 400px;
            height: 66vh;
        }

        @media (min-width: 1440px) {
            width: 450px;
        }
  `}
`;

const ChatbotWindow: FC<ChatbotWindowProps> = ({ children, isChatbot = false }) => {
    const windowWidth = useWindowWidth();
    const isMobile = windowWidth <= 767;

    return (
        <Container isChatbot={isChatbot} isMobile={isMobile}>
            <WindowWrapper isChatbot={isChatbot}>
                {children}
            </WindowWrapper>
        </Container>
    );
};

export default ChatbotWindow;
